import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import routes from './routes/routes';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Sidebar from './components/admin_pannel/adminSidebar';
import AdminHeader from './components/admin_pannel/adminHeader';

const AppContent = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  const renderRoutes = (routesArray) =>
    routesArray.map(({ path, element: Element }) => (
      <Route key={path} path={path} element={<Element />} />
    ));

  return (
    <div className="App relative">
      {isAdminRoute ? <AdminHeader /> : <Header />}

      <div>
        {isAdminRoute && <Sidebar/>}

        <main style={{ padding: isAdminRoute ? '20px' : '' }}>
          <Routes>
            {renderRoutes(routes.public)}
            {renderRoutes(routes.dashboard)}
            {renderRoutes(routes.admin)}
          </Routes>
        </main>
      </div>

      {!isAdminRoute && <Footer />}

      { !isAdminRoute && <a  href="https://wa.me/923207110715" target="_blank" rel="noopener noreferrer">
        <img
          src="./assets/whatsapp.png"
          alt="WhatsApp"
          style={{ position: 'fixed', bottom: '16px', right: '20px', height: '90px', width: '90px', cursor: 'pointer' }}
        />
      </a>}
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
